import React from "react";
import Header from "../Components/Header/Header";
import HeroSection from "../Components/HeroSection/HeroSection";
import CompaniesList from "../Components/CompaniesListComponent/CompaniesList";
import ChatbotSection from "../Components/ChatbotSection/ChatbotSection";
import Footer from "../Components/Footer/Footer";

function Home() {
  return (
    <>
      <Header />
      <HeroSection />
      <ChatbotSection />
      <CompaniesList />
      <Footer />
    </>
  );
}

export default Home;
